import { __read } from "tslib";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, ClickAwayListener } from "@material-ui/core";
import { isEqual } from "lodash";
import FilterIcon from "../../../assets/icons/Icon_filter.svg";
import FilterIconActive from "../../../assets/icons/Icon_filter_active.svg";
import MultipleCheckboxFilter from "../columnFilters/MultipleCheckbox";
import { FilterTypes } from "../columnFilters/types";
import { useStyles } from "../styles";
var ColumnFilterWrapper = function (_a) {
    var _b;
    var _c = _a.filter, type = _c.type, data = _c.data, onChange = _c.onChange, width = _c.width;
    var classes = useStyles();
    var _d = __read(useState(false), 2), viewFilterWrapper = _d[0], setViewFilterWrapper = _d[1];
    var _e = __read(useState(data), 2), filterValue = _e[0], setFilterValue = _e[1];
    var filterRef = useRef(data);
    useEffect(function () {
        if (filterRef.current) {
            filterRef.current = filterValue;
        }
    }, [filterValue]);
    var getFiltersIds = function (data) {
        return data.allFilters.checked
            ? data.checkboxFilters.map(function (_a) {
                var id = _a.id;
                return "" + id;
            })
            : data.checkboxFilters.filter(function (item) { return item.checked; }).map(function (_a) {
                var id = _a.id;
                return "" + id;
            });
    };
    var handleClickAway = function () {
        if (!viewFilterWrapper) {
            return;
        }
        var oldValues = getFiltersIds(data);
        var newValues = getFiltersIds(filterRef.current);
        if (!isEqual(oldValues, newValues)) {
            onChange(filterRef.current);
        }
        setViewFilterWrapper(false);
    };
    var hasFilters = useMemo(function () { return filterRef.current.allFilters.checked || filterRef.current.checkboxFilters.some(function (filter) { return filter.checked; }); }, [filterRef.current]);
    var ColumnFilterComponents = (_b = {},
        _b[FilterTypes.MultipleCheckbox] = (React.createElement(MultipleCheckboxFilter, { multipleCheckbox: filterValue, setMultipleCheckbox: setFilterValue })),
        _b);
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
        React.createElement("div", { className: classes.filterContainer },
            React.createElement("img", { src: viewFilterWrapper || hasFilters ? FilterIconActive : FilterIcon, alt: "filter icon", className: classes.columnFilterIcon, onClick: function () { return setViewFilterWrapper(true); } }),
            viewFilterWrapper && (React.createElement(Box, { className: classes.filterWrapper, style: { width: width !== null && width !== void 0 ? width : "auto" } }, ColumnFilterComponents[type])))));
};
export default ColumnFilterWrapper;
//# sourceMappingURL=ColumnFilterWrapper.js.map